import React from 'react';
import { Navigate } from 'react-router-dom';

const STORAGE_KEY = 'menubazzar_signup_invite';
const MAX_AGE_MS = 60 * 60 * 1000; // 1 hour (should match backend invite TTL)

export function getInviteSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.inviteToken || !parsed?.savedAt) return null;
    if (Date.now() - Number(parsed.savedAt) > MAX_AGE_MS) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveInviteSession(inviteToken) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ inviteToken: String(inviteToken), savedAt: Date.now() })
  );
}

export function clearInviteSession() {
  localStorage.removeItem(STORAGE_KEY);
}

function SignupProtectedRoute({ children }) {
  // Allow: invite token in URL (first load) OR stored invite session.
  const params = new URLSearchParams(window.location.search);
  const inviteFromUrl = params.get('invite');

  if (inviteFromUrl) {
    saveInviteSession(inviteFromUrl);
    // Optional: keep the URL clean
    window.history.replaceState({}, document.title, window.location.pathname);
    return children;
  }

  const inviteSession = getInviteSession();
  if (!inviteSession) {
    return <Navigate to="/signup-access" replace />;
  }

  return children;
}

export default SignupProtectedRoute;
